import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { FaGoogle, FaFacebook, FaLinkedin, FaGithub, FaMicrosoft } from 'react-icons/fa';

const Login = () => {
  const { isAuthenticated, login } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/members" replace />;
  }

  const providers = [
    { name: 'google', icon: FaGoogle, label: 'Google', color: 'bg-red-600 hover:bg-red-700' },
    { name: 'facebook', icon: FaFacebook, label: 'Facebook', color: 'bg-blue-600 hover:bg-blue-700' },
    { name: 'linkedin', icon: FaLinkedin, label: 'LinkedIn', color: 'bg-blue-700 hover:bg-blue-800' },
    { name: 'github', icon: FaGithub, label: 'GitHub', color: 'bg-gray-800 hover:bg-gray-900' },
    { name: 'microsoft', icon: FaMicrosoft, label: 'Microsoft', color: 'bg-blue-500 hover:bg-blue-600' },
  ];

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="min-h-screen flex items-center justify-center pt-20 pb-12">
      <div className="container-custom max-w-md">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          className="card"
        >
          <div className="text-center mb-8">
            <h2 className="text-3xl font-display font-bold mb-2">Welcome Back</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Sign in to access exclusive content and features
            </p>
          </div>

          <div className="space-y-3">
            {providers.map((provider, index) => (
              <motion.button
                key={provider.name}
                initial="hidden"
                animate="visible"
                variants={fadeIn}
                transition={{ delay: index * 0.1 }}
                onClick={() => login(provider.name)}
                className={`w-full flex items-center justify-center gap-3 px-6 py-3 ${provider.color} text-white rounded-lg transition-all duration-300 transform hover:scale-105`}
              >
                <provider.icon size={20} />
                <span className="font-medium">Continue with {provider.label}</span>
              </motion.button>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700 text-center text-sm text-gray-600 dark:text-gray-400">
            <p>
              By signing in, you agree to our{' '}
              <a href="#" className="text-[rgb(var(--color-accent))] hover:underline">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="#" className="text-[rgb(var(--color-accent))] hover:underline">
                Privacy Policy
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
